import { render } from "./Step4.vue?vue&type=template&id=2e6ccf46&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import "./Step4.vue?vue&type=style&index=0&id=2e6ccf46&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6ccf46"]])

export default __exports__